import script from "./GalleryView.vue?vue&type=script&lang=ts&setup=true"
export * from "./GalleryView.vue?vue&type=script&lang=ts&setup=true"

import "./GalleryView.vue?vue&type=style&index=0&id=7dd41505&lang=scss&scoped=true"

import exportComponent from "/Users/ckullmus-heege/Documents/dj-daniel-daub/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7dd41505"]])

export default __exports__